import { FC } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import SimpleImage from "../../Shared/Media/SimpleImage";
import { NML_ALUMNI_INTERVIEWS } from "../../../Config/Static/NmlAlumniInterview";

interface Props {
  pageId: string;
}

type Section = {
  image?: string;
  heading: string;
  content: string;
};

const NmlAlumniInterview: FC<Props> = ({ pageId }) => {
  const pageData = NML_ALUMNI_INTERVIEWS.find((x) => x.key === pageId);
  if (!pageData) return null;

  return (
    <div className="alumni-interview-main">
      {/* Profile Card */}
      <div className="alumni-interview-profile-card">
        <Container>
          <Row className="gx-5">
            <Col lg={5} xs={12} className="col">
              <div className="profile-card-img">
                <SimpleImage
                  src={pageData.headerImage}
                  className="img-fluid full-width"
                />
              </div>
            </Col>
            <Col lg={7} xs={12} className="d-flex align-items-center">
              <div className="alumni-interview-profile-card-content h-100 d-flex flex-column justify-content-center">
                <h1 style={{ whiteSpace: "pre-wrap" }}>
                  <FormattedMessage id={pageData.headerTitle} />
                </h1>
                <p>
                  <FormattedMessage
                    id={pageData.headerDesignationDetails}
                    values={{ br: <br /> }}
                  />
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Intro Part */}
      <Container className="alumni-interview-intro-part">
        <Row className="align-items-center">
          <Col>
            <p>
              <FormattedMessage id={pageData.intro} />
            </p>
          </Col>
        </Row>
      </Container>
      {/* Section Part */}
      {pageData.sections.map((section: Section) => (
        <Container key={section.heading} className="alumni-interview-sections">
          <Row className="align-items-center">
            {section.image && (
              <Col xs={12}>
                <SimpleImage
                  src={section.image}
                  alt={`Interview Section ${section.heading}`}
                  className="img-fluid w-100"
                />
              </Col>
            )}
            <Col xs={12}>
              <Row className="gap-4">
                <h4 style={{ whiteSpace: "pre-wrap" }}>
                  <FormattedMessage id={section.heading} />
                </h4>
                <p>
                  <FormattedMessage
                    id={section.content}
                    values={{ br: <br /> }}
                  />
                </p>
              </Row>
            </Col>
          </Row>
        </Container>
      ))}
    </div>
  );
};

export default NmlAlumniInterview;
